import {Driver} from "types/entities/Driver";
import RegistrationAction from "./RegistrationAction";
import update from "immutability-helper";
import {DriverAccessCardResponse} from "types/entities/DriverAccessCard";

export interface ReducerRegistrationState {
    accounts: Driver[];
}

export interface RegistrationSetAccountAction {
    payload: Driver;
    type: typeof RegistrationAction.SET_ACCOUNT;
}

export interface RegistrationRemoveGuestAction {
    payload: Driver;
    type: typeof RegistrationAction.REMOVE_GUEST;
}

export interface RegistrationSetSignatureAction {
    payload: Driver;
    type: typeof RegistrationAction.SET_SIGNATURE;
}

export interface RegistrationSetWristbandAction {
    payload: DriverAccessCardResponse;
    type: typeof RegistrationAction.SET_WRISTBAND;
}

type RegistrationReducerAction = RegistrationSetAccountAction | RegistrationRemoveGuestAction | RegistrationSetSignatureAction | RegistrationSetWristbandAction;

class RegistrationReducer {
    initialState: ReducerRegistrationState = {
        accounts: [],
    };

    reducer = (state: ReducerRegistrationState = this.initialState, action: RegistrationReducerAction): ReducerRegistrationState => {
        switch (action.type) {
            case RegistrationAction.SET_ACCOUNT:
                const accountIndex = state.accounts.findIndex(account => account.id === action.payload.id);

                if (accountIndex === -1) {
                    return update(state, {
                        accounts: {
                            $push: [action.payload],
                        },
                    });
                }

                return update(state, {
                    accounts: {
                        [accountIndex]: {
                            $set: action.payload,
                        },
                    },
                });

            case RegistrationAction.SET_WRISTBAND:
                const accountWristbandIndex = state.accounts.findIndex(account => account.id === action.payload.driver_id);

                return update(state, {
                    accounts: {
                        [accountWristbandIndex]: {
                            driverAccessCard: {
                                $set: action.payload.driverAccessCards,
                            },
                        },
                    },
                });

            case RegistrationAction.REMOVE_GUEST:
                const filteredGuests: Driver[] = [];
                filteredGuests.push(action.payload, ...action.payload.familyAccounts);
                return update(state, {
                    accounts: {
                        $set: filteredGuests,
                    },
                });

            default:
                return state;
        }
    };
}

export default RegistrationReducer;
